import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
  Injector, ChangeDetectorRef
} from '@angular/core';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { IdynamicFormItem } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import { Widget } from '@ispm/widgets/decorator/widget.decorator';
import {Observable, Subject} from 'rxjs/Rx';
import { catchError, takeUntil, take } from 'rxjs/operators';
import { AgregationService } from '@ispm-client/modules/aggregator/services';
import { uniq, get, set, isEqual, isNull, groupBy } from 'lodash';
import { GetModelContextService } from '@ispm-client/modules/selection-item/services/get-model-context.service';
import { isEmpty, find} from 'lodash';
import {DataNotificationService} from "@ispm-client/modules/selection-item/services/data-notification.service";
import {GetItemsDataService} from "@ispm-client/modules/selection-item/services/get-items-data.service";
import { FloatingPanelService } from "@ispm-client/modules/selection-item/services/floating-panel.service";
import { IRevision } from "@ispm/workflow/interfaces/revision.interface";
import { Store, select } from '@ngrx/store';
import {IgenomicsState} from '@ispm/core/interfaces/genomics-state.interface';
import {NOTIFICATION_MESSAGE} from "@ispm-client/modules/aggregator/services/consts";
import {disableItem} from "@ispm-client/modules/selection-item/interfaces/floatingPanel.interface";
import {FormulaService} from "@ispm/shared/services/formula.service";
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';
import {TestService} from "@ispm/test/services/test.service";
import { WorklistNavigationService } from '@ispm/test/services/worklist-navigation.service';

const mdtAppId: string = 'ISPM-ONCOLOGY-TUMOR-BOARD-APP';

@Component({
  selector: 'gen-floating-panel',
  templateUrl: './floating-panel.component.html',
  styleUrls: ['./floating-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('FloatingPanel')
export class FloatingPanelComponent implements OnInit, IWidgetItem {
  public floatingWidgetPayload: any;
  public formData: any;
  public formsPayload: any = [];
  public panelOpen: boolean = false;
  public title: string = '';
  public updated: boolean = false;
  public hasUpdatedFields: boolean = false;
  public payload: any;
  public submitted: boolean = false;
  public validationArray: boolean[] = [];
  public resetForm: boolean = false;
  public formId: string;
  public changedFields: any = { };
  public dataNotificationformId: any = { };
  public submitButtonName: string = '';
  public additionalSearchValues: any = { };
  public permitItemSelectionWrite: boolean;
  public permitItemSelectionRead: boolean;
  public datamodelContext: any = [];
  public datamodelAttributes: any;
  public fixedPanel: boolean = false;
  public wrapperIdentifier: string;
  public floatingPanelWidth: string;
  public disableNextActionByValidation: boolean = false;
  protected destroyed$: Subject<void> = new Subject();
  public itemsSaved: boolean = false;
  public decisionStatus: boolean = true;
  private activeJobPurpose: string = '';
  private disableNextButtonOnDecisions: any;
  private store: any;
  private completeStepOnDecision: any;
  public loading: boolean = false;
  @ViewChild('itemsPanel', { static: false, read: ElementRef}) public panel: ElementRef;

  private activeTabAndStepMapper = {
    'eligibility': 'eligibilityWrapper',
    'ldct': 'ldctWrapper',
    'diagnosticfollowup': 'diagnosticFollowupWrapper',
    'newfindings': 'newFindingsWrapper'
  } as const;

  /**
   * set floating panel configuration
   * @param {IdynamicFormItem} _itemConfig
   */
  set widgetConfig(_itemConfig: IdynamicFormItem) {
    this.floatingWidgetPayload = _itemConfig;
    this.floatingPanelWidth = this.floatingWidgetPayload.width + '%';
    this.disableNextActionByValidation = get(this.floatingWidgetPayload.widgetPayload, 'disableNextByValidation');
    this.disableNextButtonOnDecisions = get(this.floatingWidgetPayload.widgetPayload, 'disableNextButtonOnDecisions', {});
    this.formsPayload = this.floatingWidgetPayload.widgetPayload.floatingPanels;
    this.store.select('currentMDTConfig').take(1).subscribe(data => {
      // overriding the formId on basis of MDT type
      if (sessionStorage.getItem('currentApplication')) {
        const currentAppId: string = JSON.parse(sessionStorage.getItem('currentApplication')).id;

        if (currentAppId && currentAppId === mdtAppId && data?.decisionCaptureTemplate) {
          this.formsPayload[0].formId = data.decisionCaptureTemplate;
        }
      }

      this.formId = this.formsPayload[0].formId;
      this.completeStepOnDecision = get(this.floatingWidgetPayload.widgetPayload, 'completeStepOnDecision', null);
      if(this.formId) {
        this._getItemsDataService.getFormIdentifier(this.formId).subscribe(formItemList => {
          this.wrapperIdentifier = formItemList[0].name;
        });
      }
      if(this.disableNextActionByValidation) {
        this.dataAvailabilityStatus(this.formId);
      }
      this.dataNotificationformId = this.formsPayload[0].dataNotificationformId;
      this._dataNotificationService.sendFormId(this.dataNotificationformId);
      this.title = this.formsPayload[0].title;
      const decisionAutoSave = get(this.testService, 'testConfiguration.decisionAutoSave', false);
      if(decisionAutoSave) {
        this.submitButtonName = "";
      }else {
        this.submitButtonName = this.formsPayload[0].submitButtonName;
      }
      this.panelOpen = this.formsPayload[0].fixedPanel ? true : false;
      this.fixedPanel = this.formsPayload[0].fixedPanel;
      this._getModelContextService.getDatamodelAttributes().subscribe( data => {
        let activeRevisionItem = find(get(data, 'workflowRequest.revisions'), ['id', get(data, 'workflowRequest.activeRevision')]);
        let activeJobItem = find(get(activeRevisionItem,'items'), ['id', get(data, 'workflowRequest.activeJob')]);
        this.activeJobPurpose = get(activeJobItem, 'purpose', '');
      });

      if(get(_itemConfig.widgetPayload, 'requiredPermissionsIds')) {
        let read = get(_itemConfig.widgetPayload.requiredPermissionsIds, 'read');
        let write = get(_itemConfig.widgetPayload.requiredPermissionsIds, 'write');
        this.permitItemSelectionRead = this._getItemsDataService.permissions(_itemConfig.widgetPayload, read);
        this.permitItemSelectionWrite = this._getItemsDataService.permissions(_itemConfig.widgetPayload, write);
        this._getModelContextService.setPermission(this.permitItemSelectionWrite);
      }
    });
  }

  set widgetData(widgetData) {
  }

  widgetUpdateValueCallback: (value) => void;

  constructor(private _agregationService: AgregationService,
              private notificationMessageService: NotificationMessageService,
              private notificationMessage: NOTIFICATION_MESSAGE,
              protected injector: Injector,
              private _getModelContextService: GetModelContextService,
              private authService: AuthenticationService,
              private _dataNotificationService : DataNotificationService,
              private _getItemsDataService: GetItemsDataService,
              private _floatingPanelService: FloatingPanelService,
              private changeDetector: ChangeDetectorRef,
              private testService: TestService,
              private workflowNavigationService: WorklistNavigationService,
              store: Store<IgenomicsState>) {
         this.store = store;
  }

  /**
   * Based on the role permission is given for read/write access
   */


  ngOnInit() {
    this._agregationService.registerForTestBarButtonStatus(this.constructor.name);
    this._getModelContextService.datamodelContextObservable.subscribe(data => {
      if(!isEmpty(data)) {
        this.datamodelContext = data.context;
        this.datamodelAttributes = data.attributes;
      }
    });
    this._dataNotificationService.changeEmitted$.pipe(
      take(1),
      takeUntil(this.destroyed$)
    ).subscribe(() => {
      const data = {
        formData: this.formsPayload,
        isValid: true,
        hasUpdatedFields: this.hasUpdatedFields
      };
      const context = this;
      if (data.isValid) {
        return context.submitForm(data)
          .then(resp => {
            this.notificationMessageService.success(this.notificationMessage.Patient_details_updated_successfully);
            this.loading = false;
            this.changeDetector.markForCheck();
            this._dataNotificationService.confirmNextButton(true);
          })
          .catch(err => {
            this.loading = false;
            this._dataNotificationService.confirmNextButton(false);
          });
      }
    });
  }


  /**
   * triggeres when there is change in the form
   * @param formData
   * @param index
   */
  formChanged(formData, index) {
    this.resetForm = false;
   // this._getModelContextService.setParentChanges(formData.form);
    if (formData.updated) {
      this.hasUpdatedFields = true;
    }
    this.formsPayload[index].formData = formData.form;
    if (!get(this.formsPayload[index], 'updatedFields')) {
      set(this.formsPayload[index], 'updatedFields', []);
    }
    get(this.formsPayload[index], 'updatedFields').push(...formData.updated);
    const stepsToContinue = ["eligibilityWrapper", "ldctWrapper", "newFindingsWrapper", "diagnosticFollowupWrapper"];
    let stepWrapperName = Object.keys(formData.form)[0];
    const activeJobStep = this.activeJobPurpose.toLowerCase();
   // TODO use lodash get for all []
    if(formData.form[stepWrapperName] && stepsToContinue.includes(stepWrapperName) && (this.activeTabAndStepMapper[activeJobStep]?.toLowerCase() == stepWrapperName?.toLowerCase())) {
      if(typeof formData.form[stepWrapperName].priority != 'undefined' && formData.form[stepWrapperName].priority.length == 1) {
        this._agregationService.enableDisableTestBarButton(this.constructor.name, true);
      }
      if(typeof formData.form[stepWrapperName].priority != 'undefined' && formData.form[stepWrapperName].priority.length == 0) {
        this._agregationService.enableDisableTestBarButton(this.constructor.name, false);
      }
    }
    if(formData.form["newFindingsWrapper"] && formData.form[stepWrapperName].priority && formData.form["newFindingsWrapper"].priority.length == 1 && (this.activeTabAndStepMapper[activeJobStep].toLowerCase() == stepWrapperName.toLowerCase())) {
      this._agregationService.enableDisableTestBarButton(this.constructor.name, true);
    }
    if(formData.form["newFindingsWrapper"] && formData.form[stepWrapperName].priority && formData.form["newFindingsWrapper"].priority.length == 0) {
      this._agregationService.enableDisableTestBarButton(this.constructor.name, false);
    }
    this.workflowNavigationService.setSelectedFormValue(formData.form[stepWrapperName]);
  }

  /**
   * Called on submit
   * @param submittedData
   * @returns {Promise<{isValid: boolean; resp; changed: boolean} | {isValid: boolean}>}
   */
  submit(submittedData) {
    this.submitted = true;
    this.loading = true;
    if(this.validationArray.length == 0 && !this.hasUpdatedFields){
      this.notificationMessageService.error(this.notificationMessage.NO_MODIFIED_DATA_TO_UPDATE);
    } else  if (this.validationArray.length > 0 &&
      (!this.hasUpdatedFields || !this.validationArray.filter(e => e).every(valid => !!valid))) {
      this.notificationMessageService.error(this.notificationMessage.NO_MODIFIED_DATA_TO_UPDATE);
    }
    const data = {
      formData: this.formsPayload,
      isValid: true,
      hasUpdatedFields: this.hasUpdatedFields
    };

    const context = this;
    if (data.isValid) {
      return context.submitForm(data)
        .then(resp => {
          this.notificationMessageService.success(this.notificationMessage.Patient_details_updated_successfully);
          this.loading = false;
          this.changeDetector.markForCheck();
          return { isValid: !!resp, resp: resp, changed: true};
        })
        .catch(err => {
          this.loading = false;
          return { isValid: false};
        });
    }

  }

  /**
   * Aggregator service is called to create/update the data
   * @param submittedData
   * @returns {any}
   */
  submitForm(submittedData) {
    let postData = [];
    let postDataObj;
    const formsData = submittedData.formData;
    const newFormData = formsData;
    if(formsData.length > 0){
      let firstItem = formsData[0];
      if(firstItem['formData'] && firstItem.formData[this.wrapperIdentifier]){
        let priorityContent = firstItem.formData[this.wrapperIdentifier];
        if (isEmpty(get(priorityContent, 'formId'))) {
          set(priorityContent, 'formId', get(firstItem, 'formId', ""));
        }
        delete newFormData[0].formData[this.wrapperIdentifier];
        newFormData[0].formData = priorityContent;
      }
    }
    if (submittedData.hasUpdatedFields) {
      return new Promise((resolve, reject) => {
        for (const formItemData of newFormData) {
          postDataObj = { 'formId': formItemData.formId, 'formdata': []};
          postDataObj = this.handleTypesOfData(formItemData, postDataObj);
          if (postDataObj.formdata.length > 0) {
            postDataObj = this.addRequiredAttribute(postDataObj);
            postData.push(postDataObj);
          }
        }
        if (postData.length > 0) {
          const contextString = this.contextStringFormat();
          let contextArray:any[] = [];
          this._agregationService.interPolateWithStore(contextString).then(contxt => {
            contextArray = this.getContext(postData[0], contxt);
            postData = this.modifyPayloadToCompleteWorkflow(postData);
            this._agregationService.UpdateDataToServer(postData, contextArray).pipe(
              catchError(err => {
                this.notificationMessageService.error(this.notificationMessage.UNABLE_TO_UPDATE_PATIENT_DETAILS);
                reject(null);
                return Observable.throw(err);
              })
            ).subscribe(response => {
              if (response['code'] === 2) {
                resolve(`Patient details updated successfully!`);
                this.updated = true;
                this.hasUpdatedFields = false;
              } else if(response['code'] === 3){
                this.notificationMessageService.warning(response['display']);
                reject(null);
              } else if(response['code'] === 4){
                this.notificationMessageService.error(response['display']);
                reject(null);
              }
            });
          });
        } else {
          this.notificationMessageService.error(this.notificationMessage.NO_MODIFIED_DATA_TO_UPDATE);
          reject(null);
        }
      });
    } else {
      return Promise.reject(null);
    }
  }

  private modifyPayloadToCompleteWorkflow(postData: any[]) {
    if (!isNull(this.completeStepOnDecision)) {
      const recommendationList = get(this.completeStepOnDecision, 'recommendationList', []);
      const subTypePath = get(this.completeStepOnDecision, 'subTypePath');
      const dataPath = get(this.completeStepOnDecision, 'dataPath');
      if(!isEmpty(recommendationList)) {
        recommendationList.forEach(item => {
          const recommendationValue = get(postData, get(item, 'recommendationPath'));
          const recommendationKey = get(item, 'recommendationPath').split('.').pop();
          const formulaValue = FormulaService.evaluateFormula(get(item, 'formula'), {[recommendationKey]: recommendationValue});
          if(get(item, 'parentRef') === get(postData, get(this.completeStepOnDecision, 'formRefPath')) && formulaValue) {
            if(!isEmpty(get(item, 'dataValue'))) {
              set(postData, dataPath, get(item, 'dataValue'));
            }
            set(postData, subTypePath, get(item, 'subTypeValue'));
          }
        });
      }
    }
    return postData;
  }

  /**
   * handled different types of data
   * @param formItemData
   * @param postDataObj
   * @returns {any}
   */
  handleTypesOfData(formItemData, postDataObj): any {
    const formData = formItemData.formData;
    for (const item of uniq(formItemData.updatedFields)) {
      const formItem = formData;
      if (Array.isArray(formItem)) {
        postDataObj.formdata.push(...formItem.map(row => {
          return this.getRowData(row, item, formData);
        }).filter(row => {
          if (row.hasOwnProperty('changed')) {
            if (!row['changed']) {
              return false;
            } else {
              delete row['changed'];
            }
          }
          return true;
        }));
      } else if (typeof formItem === 'object') {
        postDataObj.formdata.push(this.getRowData(formItem, item, formData, 'object'));
      } else if (typeof formItem === 'string') {
        formData['_dataBindingIdentifier'] = item;
        postDataObj.formdata.push(formData);
        break;
      }
    }
    return postDataObj;
  }

  /**
   * modifies the row data based on type and return
   * @param row
   * @param item
   * @param formData
   * @param {string} type
   * @returns {any}
   */
  getRowData(row, item, formData, type?: string) {
    row['_dataBindingIdentifier'] = item;
    if (type !== 'object') {
      row['formId'] = formData['formId'];
    }
    delete row['__gen-selection-list__unique-item-id__'];
    return row;
  }

  /**
   * added required attributes for the datamodel
   * @param postDataObj
   * @returns {any}
   */
  addRequiredAttribute(postDataObj): any {
    for (const prop in this.datamodelAttributes) {
      if (prop) {
        postDataObj.formdata[0][prop] = this.datamodelAttributes[prop];
      }
    }

    if (postDataObj.formdata[0].priority) {
      postDataObj.formdata[0].priority = this.deleteUnwantedAttr(postDataObj.formdata[0].priority);

      if(postDataObj.formdata[0]['intent']) {
        let groupedSelectedItems = groupBy(postDataObj.formdata[0].priority, function(item) {
          return item['intent'] ? item['intent'].code: item['intent'];
        });
        postDataObj.formdata[0]['intent'] = [];
        for (let groupKey in groupedSelectedItems) {
          postDataObj.formdata[0]['intent'].push(groupedSelectedItems[groupKey][0].intent)
        }
      }

    }
    return postDataObj;
  }

  /**
   * created context in string format
   * @returns {string}
   */
  contextStringFormat(): string {
    const contextStr = this.datamodelContext.map(function(item) {
      const reference = JSON.stringify(item['reference']);
      const resourceType = JSON.stringify(item['resourceType']);
      return '{"reference":' + reference + ', "resourceType":' + resourceType + '}';
    });
    return '[' + contextStr + ']'
  }

  getContext(postData, contxt): any {
    let contextArray:any[] = [];
    const context = JSON.parse(contxt);
    if(postData && postData.formdata[0] && postData.formdata[0].context){
      context.forEach(item => {
        if(!find(postData.formdata[0].context, item)){
          contextArray.push(item);
        }
      });
    }else{
      contextArray = context;
    }
    return contextArray;
  }

  /**
   * delete the attributes
   * @param itemsData
   * @returns {Array<any>}
   */
  deleteUnwantedAttr(itemsData): Array<any> {
    itemsData.forEach(item => {
      delete item.selected;
      delete item.nodeType;
      delete item.list;
      delete item.code;
      delete item.referencePath;
      delete item.formId;
      delete item.formRefName;
      delete item.itemId;
      delete item.itemName;
      delete item.itemReferences;
      delete item['deleted'];
      delete item['updated'];
      delete item['itemRecommendedPath'];
    });
    return itemsData;
  }

  /**
   * updating form validation
   * @param {boolean} validate
   */
  updateValidate(validate: boolean) {
    if(this.disableNextActionByValidation === false) {
      this._agregationService.enableDisableTestBarButton(this.constructor.name, false);
      if(this.itemsSaved) {
        this._agregationService.enableDisableTestBarButton(this.constructor.name, true);
      }
    }
  }

  /**
   * Check items are selected or not
   * @param formId
   */
  dataAvailabilityStatus(formId) {
    this._dataNotificationService.showDataNotification(formId)
      .takeLast(1)
      .takeUntil(this.destroyed$.asObservable())
      .subscribe(async data => {
        if (!isEmpty(data)) {
          let itemsSelected = null;
          let stage = null;
          if(Array.isArray(data)) {
            itemsSelected = get(data, 'priority');
            stage = get(data, 'stage');
          } else {
            itemsSelected = get(data[this.wrapperIdentifier], 'priority');
            stage = get(data[this.wrapperIdentifier], 'stage');
          }
          stage = stage && typeof stage === 'object' ? stage.code : stage;
          stage = stage ? stage.toUpperCase(): null;
          this.itemsSaved = itemsSelected && itemsSelected.length > 0
          && stage === this.activeJobPurpose.replace(/\s/g, "").toUpperCase() ? true : false;

          if(itemsSelected && itemsSelected.length > 0 && this.disableNextButtonOnDecisions) {
            let status = await this.nextButtonDisableOnDecisions(itemsSelected);
            if(status === false || status === true) {
              return this._agregationService.enableDisableTestBarButton(this.constructor.name, status);
            }
          }
          if(this.decisionStatus) {
            if (this.itemsSaved) {
              this._agregationService.enableDisableTestBarButton(this.constructor.name, true);
            } else {
              this._agregationService.enableDisableTestBarButton(this.constructor.name, false);
            }
          }
        }
      });
  }

  async nextButtonDisableOnDecisions(itemsSelected: Array<any>): Promise<boolean> {
    let status = null;
    let activeJobPurpose = this.activeJobPurpose.replace(/\s/g, "").toUpperCase();
    this.uppercaseKeys();
    let stageExist = get(this.disableNextButtonOnDecisions, activeJobPurpose);

    let subStatus = null;
    await this.store.pipe(select((state: any) => state.tests.diagnosticOrders.order.derivedStatus)).takeUntil(this.destroyed$).subscribe((status) => {
      if (status) {
        subStatus = status.display;
      }
    });

    if (stageExist) {
      const workflowRevision: IRevision = await this._floatingPanelService.getActiveWorkflowRevision();
      stageExist.forEach(stage => {
        let disabledItem: disableItem = stage;
        let path = get(stage, 'path');
        const selectedItem = get(itemsSelected[0], 'diagnosticPlanId');
        if (path) {
          path = path.split('.');
          let reference = get(itemsSelected[0], path[0]);
          const actionData = get(itemsSelected[0], 'data');
          const currentStatus = get(actionData, 'currentWorkflowStatus');
          if (reference.length > 0 && path && path.length > 0) {
            reference = this.getReference(path, reference);
            if (reference && reference === disabledItem.item && currentStatus === disabledItem.currentWorkflowStatus
              && (isEqual(workflowRevision.status, currentStatus) ||
                isEqual(subStatus, currentStatus))) {
              status = false;
            }
          }
          else {
            if (selectedItem === disabledItem.item && currentStatus === disabledItem.currentWorkflowStatus) {
              status = false;
            }
          }
          if(!isEmpty(disabledItem.notificationMessage)
            && (selectedItem === disabledItem.item || reference === disabledItem.item)) {
            this.notificationMessageService.warning(disabledItem.notificationMessage);
          }
        }
      });
    }
    return status;
  }

  uppercaseKeys() {
    Object.keys(this.disableNextButtonOnDecisions).forEach(key => {
      const value = this.disableNextButtonOnDecisions[key];
      delete this.disableNextButtonOnDecisions[key];
      this.disableNextButtonOnDecisions[key.toUpperCase()] = value;
    });
  }

  getReference(path: Array<any>, reference): string {
    path.forEach((ref, index) => {
      if (index !== 0) {
        if (reference && typeof reference === 'object'){
          reference = (<any> Object).values(reference);
          reference = reference[0];
        }
        if(reference && Array.isArray(reference)) {
          reference = get(reference[0], path[index+1]);
        } else {
          reference = reference && typeof reference !== 'string' ? get(reference, ref): reference;
        }
      }
    });
  return reference;
  }

  /**
   * open floating panel
   */
  openPanel() {
    this.panelOpen = true;
  }

  /**
   * close floating panel
   */
  closePanel() {
    this.panelOpen = false;
  }

  ngOnDestroy() {
    this._agregationService.enableDisableTestBarButton(this.constructor.name, false);
    this._agregationService.unRegisterToTestBarButton(this.constructor.name);
    this.destroyed$.next();
    this.destroyed$.complete();
  }

}
